import { useDispatch, useSelector } from "react-redux";

// Actions
import { openMultiCitySelectionForm } from "../../actions/campaign-planning/MultiCitySelectionFormActions";

// Constants and Utils
import { FormDataTargets } from "../../constants/GeneralConstants";

// Components
import { Input } from "../form-input/FormInput";
import BootstrapDateRangePicker from "../bootstrap-date-range-picker/BootstrapDateRangePicker";
import DurationSelector from "../../mavin/components/duration-selector/DurationSelector";
import { PlainDropdown } from "../dropdown/Dropdown";
import Spinner from "../spinner/Spinner";

// Campaign Plan Setup Header
export function PlanSetupHeader() {
  return (
    <div className="page-header shadow">
      <h2 className="">{"New Campaign"}</h2>
    </div>
  );
}

// Campaign Plan Setup Title
export function PlanSetupTitle({ title, setTitle }) {
  return (
    <div className="py-3">
      <h5>{"Campaign Title"}</h5>
      <Input
        type="text"
        placeHolder="Enter Title"
        inputBoxStyle="rounded-lg form-control shadow-none"
        id={"title"}
        value={title}
        onChange={(id, value) => {
          setTitle(value);
        }}
      />
    </div>
  );
}

// Campaign Plan Setup StartDate And Duration
export function PlanSetupStartDateAndDuration({
  startDate,
  setStartDate,
  setEndDate,
}) {
  // Style for DatePicker
  const stylesObject = {
    autoApply: true,
    border: true,
    buttonClassName: "col-12 px-0",
  };

  function handleSelectDuration(duration) {
    const date = new Date(startDate);
    setEndDate(new Date(date.setDate(date.getDate() + duration - 1)));
  }

  return (
    <div className="d-flex py-3">
      <div className="col-6 pl-0">
        <h5>{"Est. Start Date"}</h5>
        {/* Single-Date-Selector ==> isSingleDatePicker={true} */}
        <BootstrapDateRangePicker
          isSingleDatePicker={true}
          initialStartDate={startDate}
          onApplyDates={setStartDate}
          minDate={new Date()}
          placeHolder={"Select Date"}
          styleObject={stylesObject}
        />
      </div>
      <div className="col-6 pr-0">
        <h5>{"Duration"}</h5>
        <DurationSelector
          onItemSelect={handleSelectDuration}
          startDate={startDate}
          buttonClassName="shadow-none col px-2"
        />
      </div>
    </div>
  );
}

// Campaign Plan Setup TargetGroup And Budget
export function PlanSetupTargetGroupAndBudget({
  tgList,
  setTg,

  // for mantaray
  isShowBudget = false,
  budget,
  setBudget,
}) {
  // function to handle budget change
  function handleBudgetChange({ target }) {
    setBudget(target.value);
  }

  return (
    <div className="d-flex py-3">
      <div className="col-6 pl-0">
        <h5>{"Target Group"}</h5>
        <PlainDropdown
          items={tgList}
          className="btn shadow-none rounded-lg border px-3"
          placeHolder="Select Target Group"
          onItemSelect={setTg}
          dropMenuClassName="dropdown-fixed-height"
          isFirstItemSelectable={true}
        />
      </div>

      {/* Mantaray : Budget */}
      {isShowBudget && (
        <div className="col-6 pr-0">
          <h5>{"Budget"}</h5>
          <input
            type="number"
            placeholder="Enter the budget"
            className="rounded-lg form-control shadow-none"
            value={budget}
            onChange={handleBudgetChange}
          />
        </div>
      )}
    </div>
  );
}

// Campaign Plan Setup Add Cities
export function PlanSetupAddCities({ infoByCity, setInfoByCity }) {
  const dispatch = useDispatch();

  // removing city from selected cities from Popup
  function removeSelectedCityFn(e, city) {
    if (e.target.checked) {
      setInfoByCity([...infoByCity, city]);
    } else if (!e.target.checked) {
      const updatedCityData = infoByCity.filter(
        (cityObj) => cityObj.id !== city.id
      );
      setInfoByCity(updatedCityData);
    }
  }

  return (
    <>
      <div className="d-flex py-3">
        <h5>{"Cities:"}</h5>
        <div className="px-4">
          <button
            type="button"
            className="btn btn-link shadow-none p-0"
            data-toggle="modal"
            data-target={`#${FormDataTargets.multiCitySelectionForm}`}
            onClick={() => dispatch(openMultiCitySelectionForm())}
          >
            {"+ Add Cities"}
          </button>
        </div>
      </div>

      {/* Selected Cities Section */}
      {infoByCity.length > 0 && (
        <div className="row mx-0">
          {infoByCity.map((city) => {
            const { id, label } = city;
            return (
              <button
                key={id}
                className="btn border m-1 px-3 shadow-none rounded-lg"
              >
                <input
                  type="checkbox"
                  className="cursor-pointer"
                  checked={true}
                  onChange={(e) => removeSelectedCityFn(e, city)}
                />
                <label className="pl-1 mb-0">{label}</label>
              </button>
            );
          })}
        </div>
      )}
    </>
  );
}

// Campaign Plan Setup Footer
export function PlanSetupFooter({ handleSubmit, disable }) {
  const createCampaignLoader = useSelector(
    (state) => state.campaign.createCampaignLoader
  );

  return (
    <>
      {/* divider */}
      <hr className="divider"></hr>

      {/* button */}
      <div className="d-flex justify-content-end mt-4">
        <button
          disabled={disable || createCampaignLoader}
          onClick={handleSubmit}
          className="btn btn-primary rounded-lg shadow-none"
        >
          {"Create Campaign"}
          {createCampaignLoader && (
            <Spinner className="spinner-border-sm text-light mx-1" />
          )}
        </button>
      </div>
    </>
  );
}
